import Flag from "../../assets/img/flag.svg";

type Props = {
  currentLang: string;
  isLangChanging: boolean;
  onChange: (lang: string) => void;
};

function LanguageSwitcher({ currentLang, isLangChanging, onChange }: Props) {
  const isSpanish = currentLang?.toLowerCase().startsWith("es");

  if (isSpanish) {
    return (
      <div
        className={`language-switch-container language-switch-container-es${
          isLangChanging ? " disabled" : " cursor-pointer"
        }`}
        onClick={() => !isLangChanging && onChange("en-us")}
        role="button"
        tabIndex={0}
        onKeyDown={(ev) => {
          if (ev.key === "Enter" || ev.key === " ") {
            ev.preventDefault();
            !isLangChanging && onChange("en-us");
          }
        }}
        aria-label="Switch to English"
      >
        <p>ES</p>
        <img
          className="flag-image"
          alt="Flag"
          src="/images/spain-flag.png"
        />
      </div>
    );
  }

  return (
    <div
      className={`language-switch-container${
        isLangChanging ? " disabled" : " cursor-pointer"
      }`}
      onClick={() => !isLangChanging && onChange("es")}
      role="button"
      tabIndex={0}
      onKeyDown={(ev) => {
        if (ev.key === "Enter" || ev.key === " ") {
          ev.preventDefault();
          !isLangChanging && onChange("es");
        }
      }}
      aria-label="Cambiar a Español"
    >
      <img className="flag-image" alt="Flag" src={Flag} />
      <p>EN</p>
    </div>
  );
}

export default LanguageSwitcher;
